import React from "react";
import { useStateContext } from "../context/ContextProvider";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdErrorOutline } from "react-icons/md";
// استخدم مكتبة أيقونات مناسبة للويب
import { useTranslation } from "react-i18next";
import { Button } from "./layout";

const VerificationModel = ({
  modalVisible,
  setModalVisible,
  requestMessage,
  successful,
  persistLoginAfterOTPVerification,

}) => {
  const buttonHandler = () => {
    if (successful) {
   
        persistLoginAfterOTPVerification();
    
     
    }
    setModalVisible(false);
  };

  if (!modalVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className=" bg-back-secondary rounded-2xl dark:bg-back-darksecondary backdrop-blur-3xl   border border-n-2/50 min-w-[20rem] shadow-md max-w-xl p-10 relative items-center justify-center">
        <div>
          {!successful ? (
            <FailContent
              buttonHandler={buttonHandler}
              errorMsg={requestMessage}
            />
          ) : (
            <SuccessContent buttonHandler={buttonHandler} />
          )}
        </div>
      </div>
    </div>
  );
};

const SuccessContent = ({ buttonHandler }) => {
  // قم بتخصيص الألوان حسب الوضع
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center flex-col">
      <div className=" absolute  -top-5 bg-green-600  flex items-center justify-center rounded-full p-3 center">
        <IoMdCheckmarkCircleOutline className="text-n-1 dark:text-back-darksecondary" size={30} />
      </div>
      <h2 className="h4 text-green-600 my-3">{t("Verified")}</h2>
      <p className="mb-2 text-tcolor-5 dark:text-tcolor-2 body-1">
        {t("You have successfully verified your account")}
      </p>
      <Button onClick={buttonHandler} Bstyle={"bg-green-600 text-n-1"} text= {t("Continue")} />
      
    
    </div>
  );
};

const FailContent = ({ errorMsg, buttonHandler }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center flex-col">
      <div className=" absolute  -top-5 bg-red-600  flex items-center justify-center rounded-full p-3 center">
        <MdErrorOutline size={30} />
      </div>
      <h2 className="h2 text-red-600 my-3">{t("Failed")}</h2>
      <p className="mb-2 body-1">
        {t("Oops! Account verification failed")} {errorMsg}
      </p>
      <Button onClick={buttonHandler} style={"bg-red-600"} text={t("Try Again")} />
      
  
    </div>
  );
};

export default VerificationModel;
